import { render, staticRenderFns } from "./ThanksSingle.vue?vue&type=template&id=23fafd9a"
import script from "./ThanksSingle.vue?vue&type=script&lang=js"
export * from "./ThanksSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports